<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  KkIcon
} from '../../../../components/base'

const { t } = useI18n()
const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  currentPage: {
    type: Number,
    required: true
  },
  displayNumber: {
    type: Number,
    required: true
  },
  postsLength: {
    type: Number,
    required: true
  },
  totalPages: {
    type: Number,
    required: true
  },
})

const emit = defineEmits(['onChangeDisplayNumber', 'goPrevPage', 'goNextPage'])
const onChangeDisplayNumber = ($event)=> {
  emit('onChangeDisplayNumber', $event)
}
const goPrevPage = ()=> {
  emit('goPrevPage')
}
const goNextPage = ()=> {
  emit('goNextPage')
}

const startDataNumber = computed(() => (props.currentPage - 1) * props.displayNumber + 1)
const endDataNumber = computed(() => startDataNumber.value + props.postsLength - 1)
</script>

<template>
  <div v-if="!props.loading && props.postsLength > 0" class="p-controller">
    <div class="p-controller__count">
      <p class="p-controller__count__name">{{ t('labels.perPageCount') }}</p>
      <div class="p-controller__count__select">
        <select :value="props.displayNumber" @change="onChangeDisplayNumber($event)">
          <option v-for="item in 5" :key="item" :value="item * 50">{{ item * 50 }}</option>
        </select>
      </div>
      <p class="p-controller__count__current">{{ startDataNumber }}-{{ endDataNumber }}</p>
    </div>
    <div class="p-controller__navi">
      <button
        type="button"
        :disabled="props.loading || props.currentPage === 1"
        class="p-controller__navi__prev"
        @click="goPrevPage"
      >
        <KkIcon name="arrowLeft" color="rgba(58, 59, 63, 0.7)" />
      </button>
      <button
        type="button"
        :disabled="props.loading || props.currentPage >= props.totalPages"
        class="p-controller__navi__next"
        @click="goNextPage"
      >
        <KkIcon name="arrowRight" color="rgba(58, 59, 63, 0.7)" />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

</style>
